// Acknowledgement popup shown (PFL only) when addUser fails because the lead
// was disqualified in a previous attempt.
export const DISQUALIFICATION_ACKNOWLEDGEMENT = {
  HEADING: "Confirm",
  CONFIRM_BUTTON_TEXT: "Confirm",
  TEXT_BEFORE_LINK:
    "I acknowledge that the lead was disqualified in a previous attempt and have reviewed the ",
  LINK_TEXT: "reason codes, descriptions and statuses",
  TEXT_AFTER_LINK: ".",
  REASON_CODE_COLUMN: "Reason Code",
  DESCRIPTION_COLUMN: "Description",
  STATUS_COLUMN: "Status"
};

export const MOBILE_NUMBER_LENGTH = 10;
export const PAN_LENGTH = 10;
